import * as plSteps from './locales/pl.json';
import * as enSteps from './locales/en.json';
import * as StepsCollectors from './lib/collectors/step-types';
export * from './lib/step-types';

export { StepsCollectors, plSteps, enSteps };
